// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Timer_timerTxt__1G95W {
  font-size: 14px;
  transition: all 0.4s ease-out;
}
.Timer_hideTimer__1uyb- {
  opacity: 0;
}
.Timer_showTimer__vPvnU {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Timer/Timer.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ","sourcesContent":[".timerTxt {\r\n  font-size: 14px;\r\n  transition: all 0.4s ease-out;\r\n}\r\n.hideTimer {\r\n  opacity: 0;\r\n}\r\n.showTimer {\r\n  opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timerTxt": `Timer_timerTxt__1G95W`,
	"hideTimer": `Timer_hideTimer__1uyb-`,
	"showTimer": `Timer_showTimer__vPvnU`
};
export default ___CSS_LOADER_EXPORT___;
